import React from "react";
import { Construction, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function PlaceholderPage({ title, description, icon: Icon = Construction, backTo }) {
  return (
    <>
      <div className="max-w-2xl mx-auto text-center py-16" data-testid="placeholder-page">
        <div className="w-20 h-20 mx-auto rounded-3xl bg-brand-purpleLight flex items-center justify-center mb-6">
          <Icon className="w-10 h-10 text-brand-purple" />
        </div>
        <h1 className="font-heading text-4xl font-semibold text-foreground tracking-tight" data-testid="placeholder-title">
          {title}
        </h1>
        <p className="text-lg text-brand-inkMuted mt-3 max-w-md mx-auto">
          {description || "This space is being lovingly crafted. Check back soon!"}
        </p>
        <div className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand-orange/20 text-[#E65100] px-4 py-1.5 text-sm font-semibold">
          ✨ Coming soon
        </div>
        {backTo && (
          <div className="mt-8">
            <Link to={backTo}>
              <Button variant="outline" className="rounded-full border-brand-purple/30 text-brand-purple hover:bg-brand-purpleLight">
                <ArrowLeft className="w-4 h-4 mr-1" /> Back
              </Button>
            </Link>
          </div>
        )}
      </div>
    </>
  );
}
